import './avgourmet/style';
import FormStructure from './avgourmet/form_structure';

export default FormStructure;